
export default {

  data() {
    return {
      loading: false,
      confirmar: {
        usuario_id: "",
        token: "",
      }
    };
  },

  async created() {
    await this.verificar_contrasena();
  },

  methods:
  {
    async verificar_contrasena() {
      this.confirmar.usuario_id = this.$route.params.id;
      this.confirmar.token = this.$route.params.token;

      this.loading = true;
      // console.log(this.$route.params.encriptado);
      try {
        let r = await this.$store.state.services.usuarioService.confirmar_correo(this.confirmar);
        console.log('userrrrr',r);

        if (r.data.success) {


          await this.$toast.info(r.data.message, {timeout:5000})
          this.loading = false;
          this.$router.push("/")
        } else {
          this.$toast.error("Error en la verificacion de correo electronico")
          this.loading = false;
        }
      } catch (error) {
        this.$toast.error("Error en la verificacion de correo electronico")
        this.loading = false;
        console.log(error);
      }

    }
  },
}